let logoutTimer;
let lastActivityTime = Date.now();
let isTimerActive = false;

// 환경변수로 타임아웃 시간 설정 (기본값: 24시간)
const getInactiveTimeout = () => {
  const envTimeout = process.env.REACT_APP_AUTO_LOGOUT_TIMEOUT;
  if (envTimeout) {
    return parseInt(envTimeout) * 60 * 1000; // 분 단위를 밀리초로 변환
  }

  // 개발 환경에서는 더 짧은 시간 사용
  if (process.env.NODE_ENV === 'development') {
    return 30 * 60 * 1000; // 30분
  }

  return 24 * 60 * 60 * 1000; // 24시간 (프로덕션)
};

const INACTIVE_TIMEOUT = getInactiveTimeout();

// 디바운싱을 위한 최소 간격 (5초)
const DEBOUNCE_INTERVAL = 5000;

export const startLogoutTimer = (logoutCallback) => {
  if (isTimerActive) {
    return; // 이미 타이머가 활성화되어 있으면 중복 실행 방지
  }

  clearLogoutTimer();
  isTimerActive = true;
  console.log(`Auto logout timer started (timeout: ${INACTIVE_TIMEOUT / 1000 / 60} minutes)`);

  logoutTimer = setTimeout(() => {
    console.log('Auto logout triggered due to inactivity');
    isTimerActive = false;
    logoutCallback();
  }, INACTIVE_TIMEOUT);
};

export const clearLogoutTimer = () => {
  if (logoutTimer) {
    clearTimeout(logoutTimer);
    logoutTimer = null;
    isTimerActive = false;
    // 로그 빈도 줄이기 위해 debug 레벨로 변경
    console.debug('Auto logout timer cleared');
  }
};

export const resetLogoutTimer = (logoutCallback) => {
  const now = Date.now();

  // 디바운싱: 마지막 활동으로부터 최소 간격이 지나지 않았으면 무시
  if (now - lastActivityTime < DEBOUNCE_INTERVAL) {
    return;
  }

  lastActivityTime = now;
  console.debug('User activity detected, resetting logout timer');
  clearLogoutTimer();
  startLogoutTimer(logoutCallback);
};

export const setupAutoLogout = (logoutCallback) => {
  // 초기 타이머 시작
  startLogoutTimer(logoutCallback);

  // 디바운싱된 활동 감지 함수
  const debouncedResetTimer = (() => {
    let timeoutId;
    return () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        resetLogoutTimer(logoutCallback);
      }, 100); // 100ms 디바운싱
    };
  })();

  // 사용자 활동 감지 이벤트들 (passive 옵션으로 성능 최적화)
  const events = ['click', 'keydown', 'scroll', 'mousemove'];

  events.forEach((event) => {
    window.addEventListener(event, debouncedResetTimer, {
      passive: true,
      capture: false
    });
  });

  console.log('Auto logout system initialized');

  // Return a cleanup function
  return () => {
    events.forEach((event) => {
      window.removeEventListener(event, debouncedResetTimer);
    });
    clearLogoutTimer();
    lastActivityTime = 0;
    console.log('Auto logout system cleaned up');
  };
};
